import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { BancoContaSalarioDomainModelList } from '@shared/models'
import {
  BancoDomainModel,
  BancoDomainModelList,
  TipoContaDomainModel,
  TipoContaDomainModelList,
} from '@shared/models/backend'
import { createDefaultSelectFieldProvider, SelectFieldProvider } from '@widgets/select-field/select-field-provider'
import { DadosBancariosService } from './dados-bancarios.service'

@Component({
  selector: 'app-dados-bancarios',
  templateUrl: './dados-bancarios.component.html',
  styleUrls: ['./dados-bancarios.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DadosBancariosComponent implements OnInit {
  @Input()
  formGroup: FormGroup
  @Input()
  controlPath: string
  @Input()
  tipoConta: 'corrente' | 'salario'

  dsTipoConta: string
  conta: TipoContaDomainModel
  bancosProvider: SelectFieldProvider<BancoDomainModel>
  nomeAgencia: string
  hasAgenciaCadastrada = false
  showAgenciaNaoEncontrada = false

  constructor(private changeDetector: ChangeDetectorRef, private dadosBancariosService: DadosBancariosService) {}

  get form() {
    return this.formGroup.get(this.controlPath) as FormGroup
  }

  get anexo() {
    return this.form.get('comprovanteAnexo') as FormGroup
  }
  getTitle() {
    return 'Comprovante bancário da ' + this.dsTipoConta.toLowerCase()
  }

  get labelAgencia() {
    if (!this.form.controls.codigoAgencia.value || !this.form.controls.banco.value || !this.hasAgenciaCadastrada) {
      return '-'
    }

    return this.showAgenciaNaoEncontrada
      ? 'Agência não encontrada. Se o código estiver correto desconsidere este aviso.'
      : this.nomeAgencia
  }

  ngOnInit(): void {
    this.initForm()
    this.initProviders()
  }

  initForm() {
    if (this.tipoConta === 'corrente') {
      this.conta = TipoContaDomainModelList[0]
      this.dsTipoConta = 'Conta corrente'
      this.form.controls.tipoConta.setValue(TipoContaDomainModelList[0])
    } else {
      this.conta = TipoContaDomainModelList[1]
      this.dsTipoConta = 'Conta salário'
      this.form.controls.tipoConta.setValue(TipoContaDomainModelList[1])
    }

    this.form.controls.banco.valueChanges.subscribe(() => this.onBancoChange())
    this.form.controls.codigoAgencia.valueChanges.subscribe(() => this.clearNomeAgencia())
  }

  initProviders() {
    const bancoDomainModelList = this.tipoConta === 'corrente' ? BancoDomainModelList : BancoContaSalarioDomainModelList
    this.bancosProvider = createDefaultSelectFieldProvider<BancoDomainModel>(bancoDomainModelList)
  }

  clearNomeAgencia() {
    this.nomeAgencia = ''
    this.showAgenciaNaoEncontrada = false
    this.changeDetector.markForCheck()
  }

  onBancoChange() {
    this.clearNomeAgencia()
    this.form.controls.codigoAgencia.reset()
    this.form.controls.numeroConta.reset()
    this.form.controls.digitoVerificadorConta.reset()
    this.form.controls.dadosConfirmados.reset()
    this.form.controls.comprovanteAnexo.reset()
    const codBanco = this.form.controls.banco.value?.id
    if (codBanco) {
      this.dadosBancariosService.verifyAgenciasCadastradasNoBanco(codBanco).subscribe((hasAgenciaCadastrada) => {
        this.hasAgenciaCadastrada = hasAgenciaCadastrada
      })
    }
  }

  onCodigoAgenciaBlur() {
    const codAgencia = this.leftZeroPadding(this.form.controls.codigoAgencia.value)
    this.form.patchValue({ codigoAgencia: codAgencia })
    const codBanco = this.form.controls.banco.value?.id
    if (codBanco && codAgencia && this.hasAgenciaCadastrada) {
      this.searchAgencia(codAgencia, codBanco)
    }
  }

  searchAgencia(codAgencia: string, codBanco: string) {
    this.dadosBancariosService.loadAgenciaBancaria(codAgencia, codBanco).subscribe((agenciaModel) => {
      if (agenciaModel) {
        this.nomeAgencia = agenciaModel.nomeAgencia
      } else {
        this.showAgenciaNaoEncontrada = true
      }

      this.changeDetector.markForCheck()
    })
  }

  onlyDigitsXP(text: string) {
    return text.replace(/[^0-9xpXP]/g, '')
  }

  leftZeroPadding(value) {
    return value ? ('0000' + value).slice(-4) : ''
  }
}
